import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function Roadmap() {
  return (
    <div
      className='mt-20'
      id='roadmap'
    >
      <AnimateOnScroll animation='flipIn'>
        <div className='bg-black mx-auto border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-44 py-2 px-5'>
          <h5>TOOLS AI JOURNEY</h5>
        </div>
      </AnimateOnScroll>
      <AnimateOnScroll animation='flipIn'>
        <h1 className='md:text-5xl text-3xl font-semibold text-center mt-3'>
          Our Roadmap
        </h1>
      </AnimateOnScroll>
      <div className='mt-20 md:px-0 px-5'>
        <div className='relative grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 flex-col-reverse md:gap-10 gap-5 required:'>
          <img
            src='/images/ellipse-2.png'
            alt='ellipse'
            className='absolute lg:-top-[100%] w-full block md:rotate-0 rotate-90 md:h-auto h-[300px]'
          />
          <div className='lg:translate-y-28'>
            <ul className='list-disc font-extralight'>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Website Development{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  ToolsAI Bot Release{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Social Media Verification{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Prelaunch Marketing Activities{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Community Building Efforts{' '}
                </AnimateOnScroll>
              </li>
            </ul>
          </div>
          <div>
            <ul className='list-disc font-extralight'>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Official Launch on Uniswap{' '}
                </AnimateOnScroll>
              </li>
              <li>
                <AnimateOnScroll animation='flipIn'>
                  Strategic Marketing Campaigns
                </AnimateOnScroll>
              </li>
              <li>
                <AnimateOnScroll animation='flipIn'>
                  Implementation of $TAI's Revenue Sharing V1{' '}
                </AnimateOnScroll>
              </li>
              <li>
                <AnimateOnScroll animation='flipIn'>
                  Listing on CoinMarketCap (CMC) and CoinGecko (CG){' '}
                </AnimateOnScroll>
              </li>
            </ul>
          </div>
          <div>
            <ul className='list-disc font-extralight'>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Expansion of the Community{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Global Marketing Initiatives{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Introduction of $TAI's Leaderboard and Competitions{' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Strategic Partnerships{' '}
                </AnimateOnScroll>
              </li>
            </ul>
          </div>
          <div className='lg:translate-y-28'>
            <ul className='list-disc font-extralight'>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Listing on Top Tier Centralized Exchanges (CEX){' '}
                </AnimateOnScroll>
              </li>
              <li>
                {' '}
                <AnimateOnScroll animation='flipIn'>
                  Revenue Sharing V2{' '}
                </AnimateOnScroll>
              </li>
            </ul>
          </div>
        </div>

        <AnimateOnScroll animation='flipIn'>
          <img
            src='/images/toolsai.png'
            alt='volum'
            className='w-full lg:h-[650px] h-[450px] object-cover'
          />
        </AnimateOnScroll>
      </div>
    </div>
  )
}
